import styled, { css } from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

interface IHamburgerButtonContent {
  isOpen: boolean;
}

export const HamburgerButtonWrapper = styled.button`
  background: ${theme.colors.primary.black};
  border: 0;
  border-radius: 8px;
  height: 45px;
  outline: 0;
  position: fixed;
  right: 10px;
  top: 16px;
  width: 45px;
  z-index: 11;
  display: block;
  align-self: center;
`;

const getHamburgerButtonContentStyles = ({ isOpen }: IHamburgerButtonContent) => {
  if (isOpen) {
    return css`
      right: 15px;
      &:nth-child(1) {
        top: 21px;
        transform: rotate(45deg);
        width: 24px;
      }
      &:nth-child(2) {
        opacity: 0;
      }
      &:nth-child(3) {
        top: 21px;
        transform: rotate(-45deg);
        width: 24px;
      }
    `;
  }
  return css`
    right: 12px;
    &:nth-child(1) {
      top: 11px;
      width: 18px;
    }
    &:nth-child(3) {
      top: 29px;
      width: 14px;
    }
  `;
};

export const HamburgerButtonContent = styled.div<IHamburgerButtonContent>`
  background: ${theme.colors.primary.white};
  height: 2px;
  position: absolute;
  transition: 0.8s cubic-bezier(0.86, 0, 0.07, 1);
  &:nth-child(2) {
    top: 20px;
    width: 21px;
  }
  ${getHamburgerButtonContentStyles};
`;
